module.exports = __webpack_public_path__ + "static/media/resetpass.bd6103bf.svg";